import type { InvestmentSpecCommandDataV2 } from '@festina/unitlink-general-types/unitlink'
import { FormikForm } from '@festina-life/ui/formikForms'

import type { CommandDataFormProps } from '../../commandActions/CommandDataFormAndSimulation'
import { SubPortfolioKeyInputs } from '../switchTrade/SubPortfolioKeyInputs'

const initialValues: InvestmentSpecCommandDataV2 = {
  _type: 'InvestmentSpecCommandDataV2',
}

export const InvestmentSpecFormV2 = (
  props: CommandDataFormProps<InvestmentSpecCommandDataV2>,
) => (
  <FormikForm initialValues={initialValues} {...props}>
    <SubPortfolioKeyInputs />
  </FormikForm>
)
